import { Pipe, PipeTransform } from '@angular/core';

const toSnake = (s: string): string =>
    s.replace(/([A-Z])/g, '_$1').toLowerCase();

@Pipe({
    name: 'translateToolName',
    standalone: false,
})
export class TranslateToolNamePipe implements PipeTransform {
    public transform(value: string): string {
        return `translate_tool_name_${toSnake(value)}`;
    }
}
